import { Component, OnInit } from '@angular/core';
import { BookResponse } from '@builtbybros/al-model';
import { Observable, Subject } from "rxjs";

import { QueryParam } from "../../../../shared/query-param";
import { HttpService } from "../../../../shared/http.service";
import { AlertService } from "../../../../shared/alert.service";

@Component({
  selector: 'app-selected-book-list',
  templateUrl: './selected-book-list.component.html',
  styleUrls: ['./selected-book-list.component.scss', '../../book-send.component.scss']
})
export class SelectedBookListComponent implements OnInit {
  // Search
  searchResultItems: Observable<BookResponse.BookExcerpt[]>;
  private searching = false;
  private searchTerms = new Subject<string>();

  onValidationError = false;
  selectedBooks = [];
  idsSelectedBooks = [];

  constructor(
    private alertService: AlertService,
    private httpService: HttpService
  ) {}

  ngOnInit() {
    this.searchResultItems = this.searchTerms
      .debounceTime(300)        // wait 300ms after each keystroke before considering the term
      .distinctUntilChanged()   // ignore if next search term is same as previous
      .do(() => this.searching = true)
      .switchMap(term => term ? this.searchItem(term) : Observable.of<BookResponse.BookExcerpt[]>([]))
      .catch(error => {
        this.alertService.error(error);
        return Observable.of<BookResponse.BookExcerpt[]>([]);
      })
      .do(() => this.searching = false);
  }

  search(term: string): void {
    this.onValidationError = false;
    this.searchTerms.next(term);
  }

  private searchItem(query: string): Observable<BookResponse.BookExcerpt[]> {
    const params = [
      new QueryParam('pagination', '10'),
      new QueryParam('query', query),
      new QueryParam('actives', 'true'),
    ];
    const resultObservable: Observable<BookResponse.All> = this.httpService.getWithParams('/Book/All', params, BookResponse.All);

    return resultObservable
      .map(
        itemResponse => {
          return itemResponse.objects.filter(element => {
            if (this.idsSelectedBooks.indexOf(element.id) === -1) {
              return element;
            }
          });
        },
        _error => [],
      );
  }

  addItem(value) {
    this.selectedBooks.push(value)
    this.idsSelectedBooks.push(value.id);
  }

  delete(value) {
    const bookIndex = this.selectedBooks.indexOf(value);
    const idIndex = this.idsSelectedBooks.indexOf(value.id);
    if (bookIndex !== -1) {
      this.selectedBooks.splice(bookIndex, 1);
      this.idsSelectedBooks.splice(idIndex, 1);
    }
  }

  cleanSearch() {
    this.searchTerms.next('');
  }

  cleanList() {
    this.selectedBooks = [];
    this.idsSelectedBooks = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/book/book-send/first-step/selected-book-list/selected-book-list.component.ts